var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlineWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.2388 11.5H18.7625C14.9625 11.5 12.75 13.725 12.75 17.5375V30.45C12.75 34.325 14.9625 36.5 18.7625 36.5H29.2388C33.1 36.5 35.25 34.325 35.25 30.45V17.5375C35.25 13.725 33.1 11.5 29.2388 11.5Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6967 29.3033C18.0003 28.6069 17.4478 27.7801 17.0709 26.8701C16.694 25.9602 16.5 24.9849 16.5 24C16.5 23.0151 16.694 22.0398 17.0709 21.1298C17.4478 20.2199 18.0003 19.3931 18.6967 18.6967M29.3034 18.6967C29.9998 19.3931 30.5523 20.2199 30.9292 21.1298C31.3061 22.0398 31.5001 23.0151 31.5001 24C31.5001 24.9849 31.3061 25.9602 30.9292 26.8701C30.5523 27.7801 29.9998 28.6069 29.3034 29.3033M21.0534 26.9458C20.2723 26.1645 19.8335 25.1048 19.8335 24C19.8335 22.8951 20.2723 21.8355 21.0534 21.0542M26.9467 21.0542C27.7279 21.8355 28.1667 22.8951 28.1667 24C28.1667 25.1048 27.7279 26.1645 26.9467 26.9458M24.8334 24C24.8334 24.221 24.7456 24.433 24.5893 24.5892C24.433 24.7455 24.2211 24.8333 24.0001 24.8333C23.7791 24.8333 23.5671 24.7455 23.4108 24.5892C23.2545 24.433 23.1667 24.221 23.1667 24C23.1667 23.779 23.2545 23.567 23.4108 23.4107C23.5671 23.2545 23.7791 23.1667 24.0001 23.1667C24.2211 23.1667 24.433 23.2545 24.5893 23.4107C24.7456 23.567 24.8334 23.779 24.8334 24Z",
    stroke: "#E5B910",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineWithBg);
export default __webpack_public_path__ + "static/media/online-with-bg.56a62ab426d41667f68204bf0e250c74.svg";
export { ForwardRef as ReactComponent };